import { LocalizationHelper } from "./LocalizationHelper";
export var LanguageOptions = [
    { key: 'en-us', text: 'English' },
    { key: 'es-es', text: 'Spanish' },
    { key: 'pt-pt', text: 'Portuguese' },
    { key: 'fr-fr', text: 'French' },
    { key: 'de-de', text: 'German' },
    { key: 'nl-nl', text: 'Dutch' },
    // { key: 'el-gr', text: 'Greek' },
    // { key: 'pl-pl', text: 'Polish' },
    // { key: 'sl-si', text: 'Sinhalese' },
    // { key: 'tr-tr', text: 'Turkish' },
    // { key: 'th-th', text: 'Thai' },
    { key: 'zh-cn', text: 'Chinese' },
    { key: 'ja-jp', text: 'Japanese' },
    { key: 'ko-kr', text: 'Korean' },
    { key: 'it-it', text: 'Italian' }
    // { key: 'id-id', text: 'Indonesian' }
];
var LanguageHelper = (function () {
    function LanguageHelper() {
    }
    LanguageHelper.getCurrentLocale = function () {
        var siteUrl = window.location.href.toLowerCase();
        var locale = {
            // default to English
            Locale: "en-us",
            Language: "en",
            LanguageId: 1033
        };
        if (siteUrl.indexOf("/en-us") != -1) {
            locale.Locale = "en-us";
            locale.Language = "en";
        }
        else if (siteUrl.indexOf("/fr-fr") != -1) {
            locale.Locale = "fr-fr";
            locale.Language = "fr";
        }
        else if (siteUrl.indexOf("/fr-ca") != -1) {
            locale.Locale = "fr-ca";
            locale.Language = "fr";
        }
        else if (siteUrl.indexOf("/de-de") != -1) {
            locale.Locale = "de-de";
            locale.Language = "de";
        }
        else if (siteUrl.indexOf("/nl-nl") != -1) {
            locale.Locale = "nl-nl";
            locale.Language = "nl";
        }
        else if (siteUrl.indexOf("/pt-br") != -1) {
            locale.Locale = "pt-br";
            locale.Language = "pt";
        }
        else if (siteUrl.indexOf("/pt-pt") != -1) {
            locale.Locale = "pt-pt";
            locale.Language = "pt";
        }
        else if (siteUrl.indexOf("/el-gr") != -1) {
            locale.Locale = "el-gr";
            locale.Language = "el";
        }
        else if (siteUrl.indexOf("/it-it") != -1) {
            locale.Locale = "it-it";
            locale.Language = "it";
        }
        else if (siteUrl.indexOf("/pl-pl") != -1) {
            locale.Locale = "pl-pl";
            locale.Language = "pl";
        }
        else if (siteUrl.indexOf("/sl-si") != -1) {
            locale.Locale = "sl-si";
            locale.Language = "sl";
        }
        else if (siteUrl.indexOf("/es-es") != -1) {
            locale.Locale = "es-es";
            locale.Language = "es";
        }
        else if (siteUrl.indexOf("/tr-tr") != -1) {
            locale.Locale = "tr-tr";
            locale.Language = "tr";
        }
        else if (siteUrl.indexOf("/ja-jp") != -1) {
            locale.Locale = "ja-jp";
            locale.Language = "ja";
        }
        else if (siteUrl.indexOf("/ko-kr") != -1) {
            locale.Locale = "ko-kr";
            locale.Language = "ko";
        }
        else if (siteUrl.indexOf("/th-th") != -1) {
            locale.Locale = "th-th";
            locale.Language = "th";
        }
        else if (siteUrl.indexOf("/zh-cn") != -1) {
            locale.Locale = "zh-cn";
            //locale.Language = "zn";
            locale.Language = "zh";
        }
        else if (siteUrl.indexOf("/id-id") != -1) {
            locale.Locale = "id-id";
            locale.Language = "id";
        }
        // TODO: extend with the rest of the supported languages
        locale.LanguageId = LocalizationHelper.getLocaleId(locale.Locale);
        return locale;
    };
    return LanguageHelper;
}());
export { LanguageHelper };

//# sourceMappingURL=LanguageHelper.js.map
